import React, { useState } from "react";
import styled from "styled-components";
import theme from "../../../assets/theme";
import Modal from "../components/Modal";
import {
  PrimaryCTAButton,
  PrimaryOutlinedCloseCTAButton,
} from "../../common/Buttons";
import { ErrorLabel } from "../../common/CustomSelect/CustomSelect";
import { CustomInputField } from "../../common/FormInputs";

const AdminCancelModal = ({ booking, onClose, onConfirm }) => {
  const [transactionId, setTransctionId] = useState("");
  const [error, setError] = useState("");

  if (!booking) return null;

  const validateForm = () => {
    const cleanedId = (transactionId || "").trim();

    if (!cleanedId) {
      setError("Please enter the payment transaction ID.");
      return false;
    }

    if (cleanedId.length < 10) {
      setError("Transaction ID must contain at least 10 characters.");
      return false;
    }

    if (!/^[a-zA-Z0-9]+$/.test(cleanedId)) {
      setError("Transaction ID can contain only letters and numbers.");
      return false;
    }

    setError("");
    return true;
  };

  const handleConfirm = () => {
    const cleanedId = (transactionId || "").trim();

    if (!validateForm()) return;

    onConfirm({
      booking_id: booking?.id,
      transaction_id: cleanedId,
      action: "confirmRefund",
    });
  };

  return (
    <Modal open={true} onClose={onClose} title="Cancel Booking" width={580}>
      <Body>
        <AlertBox>
          <AlertContent>
            <strong>Admin Cancellation</strong>
            <p>
              This action will be logged for audit. A detailed reason is
              mandatory.
            </p>
          </AlertContent>
        </AlertBox>

        <Section>
          <Label>
            Type your transaction id<span className="required-star">*</span>
          </Label>
          <CustomInputField
            variant="outlined"
            value={transactionId}
            onChange={(e) => {
              setTransctionId(e.target.value);
              if (error) setError("");
            }}
            placeholder="Enter Transaction ID"
          />
          {error && <ErrorLabel>{error}</ErrorLabel>}
        </Section>

        <Actions>
          <PrimaryOutlinedCloseCTAButton
            style={{ width: "110px", padding: "12px 12px", borderRadius: 8 }}
            onClick={onClose}
          >
            Cancel
          </PrimaryOutlinedCloseCTAButton>
          <PrimaryCTAButton
            style={{ width: "auto", padding: "12px 12px", borderRadius: 8 }}
            variant="danger"
            onClick={handleConfirm}
          >
            Confirm Cancellation
          </PrimaryCTAButton>
        </Actions>
      </Body>
    </Modal>
  );
};

export default AdminCancelModal;

const Body = styled.div`
  padding: 24px;
`;

const AlertBox = styled.div`
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  gap: 14px;
  margin-bottom: 24px;
`;

const AlertContent = styled.div`
  font-size: 13.5px;
  line-height: 1.5;
  color: #991b1b;
`;

const Label = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 11.5px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 6px;
`;

const Section = styled.div`
  margin-bottom: 24px;
`;

const Actions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  flex-wrap: wrap;
`;
